import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, input, SimpleChanges, ViewChild } from '@angular/core';
import { ImageField, KeyTextField, LinkField, RichTextField, Slice } from '@prismicio/client';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element/bundle';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';
import { SwiperDirective } from '../../../../directives/swiper.directive';
import { HTMLMapSerializer } from '@prismicio/helpers';
import { NgTemplateOutlet } from '@angular/common';
import { LinkComponent } from '../../link/link.component';

@Component({
    selector: 'app-cards-slider-slice',
    standalone: true,
    imports: [RenderHtmlPipe, SwiperDirective, NgTemplateOutlet, LinkComponent],
    templateUrl: './cards-slider-slice.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    styleUrl: './cards-slider-slice.component.scss'
})
export class CardsSliderSliceComponent implements AfterViewInit {
    body = input<CardsSlider>();
    @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;
    @ViewChild('swiperThumbs') swiperThumbs!: ElementRef<SwiperContainer>;

    currentIndex: number = 0;
    items: any[] = [];
    index: number = 0;

    swiperConfig: SwiperOptions = {
        spaceBetween: 40,
        slidesPerView: 1.2,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        loop: true,
        breakpoints: {
            768: { slidesPerView: 1.5 },
            992: { slidesPerView: 2.5 },
            1400: { slidesPerView: 3.5 },
            2300: { slidesPerView: 4.5 }
        }
    };

    headingSerializer: HTMLMapSerializer = {
        heading2: ({ children }) => '<h2 class="heading">' + children + '</h2>',
        paragraph: ({ children }) => '<p class="heading">' + children + '</p>'
    };

    titleSerializer: HTMLMapSerializer = {
        heading2: ({ children }) => '<h2 class="text-size-xl">' + children + '</h2>',
        paragraph: ({ children }) => '<p class="text-size-xl">' + children + '</p>'
    };

    htmlSerializer: HTMLMapSerializer = {
        heading3: ({ children }) => '<h3 class="text-size-m">' + children + '</h3>',
        paragraph: ({ children }) => '<p class="text-size-m">' + children + '</p>'
    };

    ngOnChanges(changes: SimpleChanges) {
        if (changes['body']) {
            this.updateItems();
        }
    }

    ngAfterViewInit() {
        /*if (this.swiper?.nativeElement?.swiper) {
            this.swiper.nativeElement.swiper.activeIndex = this.index;
        }*/
    }

    updateItems() {
        this.items = this.body()?.items || [];
    }

    next() {
        this.swiper?.nativeElement?.swiper?.slideNext();
    }

    prev() {
        this.swiper?.nativeElement?.swiper?.slidePrev();
    }
}

export type CardsSlider = Slice<
    'cards_slider',
    {
        title: RichTextField;
        heading?: RichTextField;
    },
    {
        icon: ImageField;
        badge_icon: ImageField;
        heading: KeyTextField;
        title: RichTextField;
        description: RichTextField;
        badge: KeyTextField;
        link: LinkField;
        emoji: KeyTextField;
    }
>;
